import React from 'react';
import styled from '@emotion/styled';
import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import trustAndSecurity from '../images/trust-and-security.svg';

const imgHeight = 92;

const PasswordExpiredContainer = styled.div`
  background: url(${trustAndSecurity}) no-repeat center top;
  background-size: 50% 50%;
  padding-top: ${imgHeight + gridSize() * 8}px;
`;

const Header = styled.h5`
  font: ${token('font.heading.small')};
  color: ${colors.N300};
  text-align: left;
`;

const Message = styled.p`
  margin: ${gridSize()}px 0;
`;

const Email = styled.p`
  font: ${token('font.heading.small')};
  margin-top: ${gridSize()}px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`;
interface Props {
  header?: React.ReactNode;
  children?: React.ReactNode;
  email?: string;
  message?: React.ReactNode;
}

const PasswordExpiredNotice = (props: Props) => {
  const { header, children, email, message } = props;

  return (
    <PasswordExpiredContainer id="password-expired-notice">
      <Header id="password-expired-header">{header}</Header>
      <Message id="password-expired-message">{message}</Message>
      {email && <Email>{email}</Email>}
      {children}
    </PasswordExpiredContainer>
  );
};

export default PasswordExpiredNotice;
